<template>
  <router-view name="themes" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "themes",
};
</script>
